import React from "react";
import { useWishlist } from "@/context/WishlistContext";
import { Heart } from "lucide-react";

export const HeartButton = ({ track, size = "sm" }) => {
  const { isWishlisted, toggle } = useWishlist();
  if (track.sold) return null;
  const active = isWishlisted(track.id);
  const dim = size === "lg" ? "w-5 h-5" : "w-4 h-4";
  return (
    <button
      data-testid={`wishlist-toggle-${track.id}`}
      onClick={(e) => { e.stopPropagation(); toggle(track); }}
      title={active ? "Remove from wishlist" : "Save to wishlist"}
      className="p-2 rounded-full hover:bg-white/10 transition-colors shrink-0"
    >
      <Heart className={`${dim} transition-colors ${active ? "fill-[#e2ff31] text-[#e2ff31]" : "text-[#9ca3af] hover:text-white"}`} />
    </button>
  );
};
